// extracted by mini-css-extract-plugin
module.exports = {"addPost":"AddPost_addPost__KeTzq","addPostIcon":"AddPost_addPostIcon__cdO3l","addPostText":"AddPost_addPostText__dNhns"};